export function ItemViewProcessor () {
	'use strict'
	this.itemStructure = {}
	this.itemData = {}
	this.attributesGroups = {}
	this.localization = {}
	this.language = {}

	this.setItemStructure = function (itemStructure) {
		this.itemStructure = itemStructure
	}

	this.setItemData = function (itemData) {
		this.itemData = itemData
	}

	this.setAttributesGroups = function (attributesGroups) {
		this.attributesGroups = attributesGroups
	}

	this.setLocalization = function (localization) {
		this.localization = localization
	}

	this.setLanguage = function (language) {
		this.language = language
	}
}
